type Primitive = string | number | boolean

type OptionWithValue<TValue extends Primitive> = {
  value: TValue
}

type OptionWithLabel<TValue extends Primitive> = OptionWithValue<TValue> & {
  label?: string
  labelKey?: string
}

export const findOptionByValue = <
  TOption extends OptionWithValue<Primitive>,
  TValue extends Primitive
>(
  options: readonly TOption[] | null | undefined,
  value: TValue | null | undefined
): TOption | undefined => {
  if (value === null || value === undefined) {
    return undefined
  }

  return options?.find(option => option.value === value)
}

export const getOptionLabelByValue = <TOption extends OptionWithLabel<Primitive>>(
  options: readonly TOption[] | null | undefined,
  value: TOption['value'] | null | undefined,
  params?: {
    t?: (key: string) => string
    fallback?: string
    fallbackToValue?: boolean
  }
): string => {
  const { t, fallback = '-', fallbackToValue = true } = params || {}

  if (value === null || value === undefined || value === '') {
    return fallback
  }

  const option = findOptionByValue(options, value)
  if (!option) {
    return fallbackToValue ? String(value) : fallback
  }

  if (option.labelKey) {
    return t ? t(option.labelKey) : option.labelKey
  }

  if (option.label) {
    return option.label
  }

  return fallbackToValue ? String(value) : fallback
}
